module.exports = __webpack_public_path__ + "img/Hongkong-4.205ed6d1.jpg";